import React from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => 
  createStyles({
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.body2.fontSize,
      display: "block",
      padding: "6px 0 7px",

      "&.required::after": {
        content: "' *'",
        color: "red"
      }
    },
  })
);

export type LabelProperties = React.LabelHTMLAttributes<HTMLLabelElement> & {
  required?: boolean
}

const Label = ({ children, required=false, ...props }: LabelProperties) => {
  const classes = useStyles(props);

  const classList = [
    classes.root, 
    required ? "required" : "",
    props.className
  ].join(' ').trimRight();

  return (
    <label {...props} className={classList}>
      {children}
    </label>
  );
}

export default Label;